import { useEffect } from 'react';

import type { ReactNode } from 'react';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { useSelectGoogleSettings } from '@treneo/features/config';
import { cleanupExpiredPreferences } from '@treneo/shared/utils';

type InitializerProps = { children: ReactNode };

export const Initializer = ({ children }: Readonly<InitializerProps>) => {
  const googleFromHook = useSelectGoogleSettings();
  const googleSettings = googleFromHook ?? {};

  useEffect(() => {
    cleanupExpiredPreferences();
  }, []);

  const clientId = googleSettings.clientId?.trim();
  if (!clientId) {
    return <>{children}</>;
  }
  return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
};
